angular.module('impactx.tagcloud', []);